"use client";

export default function ClientLoginLegacy() {
    return (
        <iframe
            src="/legacy-portal/page-portal-blink.html"
            style={{ width: "100%", height: "100vh", border: "none" }}
            title="Client Portal (legacy)"
        />
    );
}
